import * as React from "react";
import copy from "copy-to-clipboard";
// import { Container, InnerBox, CodeBtn, BtnWrapper } from "./styles";

import { CouponType } from "../../../services/banner";
import { TModuleWithImgProps } from "../../../services/playground";

import { ConponWrapper } from "./styles";
import { Single } from "./Components/Single";
import { Double } from "./Components/Double";
import { Three } from "./Components/Three";
import { CouponToast } from "./Components/Toast";
import { GetReceiveCouponResp } from "utils/zeusFetch";
import { CommonRuntime } from "utils/runtime";
import { trackBILog } from "../../../utils/jsBridge";

export const SuccessCode = "1000000";

export interface CouponItemProps {
  coupons: RenderCoupon[];
  handleClick: (code: string, index: number) => void;
  placeholderBg: string;
}
export interface CouponProps extends TModuleWithImgProps {
  columnSize: number;
  coupons: RenderCoupon[];
  positionId: string;
  type: CouponType;
  getCoupons: (code: string) => Promise<GetReceiveCouponResp>;
  spmClick: (order: number) => void;
  runtime: CommonRuntime;
}
export interface RenderCoupon {
  img: string;
  code: string;
  width: number;
  height: number;
}
const MCouponCode = (props: CouponProps) => {
  const {
    positionId,
    columnSize,
    type,
    language,
    spmClick,
    coupons,
    placeholderBg,
    runtime,
  } = props;
  const [showToast, setShowToast] = React.useState<boolean>(false);
  // 使用自定义Hook
  const [status, setStatus] = React.useState<number>(0);

  // 复制型优惠券
  const onClickCopyBtn = async (code: string) => {
    copy(code);
    setShowToast(true);
    trackBILog(`event/coupon/copy?code=${code}`, runtime);
  };

  // 领取型优惠券
  const onClickReceiveCoupon = (code: string) => {
    trackBILog(`event/coupon/claim?code=${code}`, runtime);
    props.getCoupons(code).then((res: GetReceiveCouponResp) => {
      setShowToast(res.code === "1000000");
      setStatus(res.info?.status);
    });
  };

  const handleClick = (code: string, index: number = 0) => {
    spmClick && spmClick(index);
    if (type === CouponType.CopyCoupon) {
      onClickCopyBtn(code);
    } else {
      onClickReceiveCoupon(code);
    }
  };

  const renderCoupon = () => {
    const commonProps: CouponItemProps = {
      coupons,
      handleClick,
      placeholderBg,
    };
    switch (columnSize) {
      case 1:
        return <Single {...commonProps} />;
      case 2:
        return <Double {...commonProps} />;
      case 3:
        return <Three {...commonProps} />;
      default:
        return <Single {...commonProps} />;
    }
  };

  const handleClose = () => {
    setShowToast(false);
  };

  return (
    <ConponWrapper id={positionId} col={columnSize}>
      {showToast && (
        <CouponToast
          type={type}
          status={status}
          language={language}
          handleClose={handleClose}
        />
      )}
      {renderCoupon()}
    </ConponWrapper>
  );
};

export default MCouponCode;
